const ms = (d) => {
    if (d == null)
        return null;
    const t = d instanceof Date ? d.getTime() : Date.parse(d);
    return Number.isFinite(t) ? t : null;
};
/**
 * `seq → timing` for every answered question, in seq order. A question with no answer, an answer that predates
 * the session start, or a clock that runs backwards yields no entry — never a guess.
 */
export function answerTimings(sessionStartedAt, answers) {
    const out = new Map();
    const origin = ms(sessionStartedAt);
    if (origin == null)
        return out;
    let cursor = origin;
    for (const a of [...answers].sort((x, y) => x.seq - y.seq)) {
        const end = ms(a.answeredAt);
        if (end == null)
            continue;
        if (end > cursor) {
            out.set(a.seq, { startSec: Math.round((cursor - origin) / 1000), endSec: Math.round((end - origin) / 1000) });
            cursor = end;
        }
    }
    return out;
}
/** The question being answered at `seconds` into the recording, or null between/outside the mapped answers. */
export function seqAt(timings, seconds) {
    for (const [seq, t] of timings)
        if (seconds >= t.startSec && seconds < t.endSec)
            return seq;
    return null;
}
//# sourceMappingURL=answerTiming.js.map